export default __webpack_public_path__ + "static/media/RENDER_.3cae203b.png";